// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/form/attachment-control/screenshot-receiver/screenshot-receiver.scss
// module id = 2050
// module chunks = 50